import { useCallback, useRef, useState } from 'react';

export interface CopyStatus {
  success: boolean;
  timestamp: number;
}

export function useCopyToClipboard(): [
  copyStatus: CopyStatus | undefined,
  showCopyFeedback: boolean,
  copyToClipboard: (text: string) => void,
] {
  const [copyStatus, setCopyStatus] = useState<CopyStatus | undefined>(undefined);
  const [showCopyFeedback, setShowCopyFeedback] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const copyToClipboard = useCallback((text: string) => {
    setCopyStatus(undefined);
    setShowCopyFeedback(false);
    clearTimeout(timeoutRef.current);

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyStatus({ success: true, timestamp: Date.now() });
      })
      .catch(() => {
        setCopyStatus({ success: false, timestamp: Date.now() });
      })
      .finally(() => {
        setShowCopyFeedback(true);
        timeoutRef.current = setTimeout(() => {
          setShowCopyFeedback(false);
        }, 2000);
      });
  }, []);

  return [copyStatus, showCopyFeedback, copyToClipboard];
}
